var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useCallback, useEffect } from 'react';
import { Checkbox, message } from 'antd';
import UserSelectionContext from '../context';
import { uniqBy } from 'lodash';
import InputAreaContext from '../../UserSelectionModal/context';
export default function (_a) {
    var dataList = _a.dataList, result = _a.result;
    var _b = React.useState(false), allChecked = _b[0], setAllChecked = _b[1];
    var _c = React.useState(false), disabled = _c[0], setDisabled = _c[1];
    var _d = React.useContext(UserSelectionContext), onSelectAll = _d.onSelectAll, single = _d.single, canSelectAll = _d.canSelectAll, maxSelectedNum = _d.maxSelectedNum, isForwardMode = _d.isForwardMode, maxSelectedSingleNum = _d.maxSelectedSingleNum, maxNumber = _d.maxNumber, totalCount = _d.totalCount;
    var strangerResult = React.useContext(InputAreaContext).strangerResult;
    var selectAll = useCallback(function () {
        var checked = !allChecked;
        var data = result.filter(function (item) { return item.visible !== false; });
        var validDataList = dataList.filter(function (item) { return !item.disabled; });
        var list = uniqBy(__spreadArrays(data, validDataList, strangerResult), 'id');
        // console.log('result:', result);
        // console.log('data:', data);
        // console.log('list:', list);
        // console.log('validDataList:', validDataList);
        // console.log('strangerResult:', strangerResult);
        if (isForwardMode) {
            var groups = list.filter(function (item1) { return item1.isGroup; }) || [];
            var singles = list.filter(function (item1) { return !item1.isGroup; }) || [];
            if (groups.length > maxSelectedNum ||
                singles.length > maxSelectedSingleNum ||
                groups.length + singles.length > maxSelectedNum + maxSelectedSingleNum) {
                message.error("\u9009\u62E9\u4F1A\u8BDD\u6570\u76EE\u5355\u804A\u4E0D\u80FD\u8D85\u8FC7" + maxSelectedSingleNum + "\u4E2A\uFF0C\u7FA4\u6C9F\u901A\u4E0D\u80FD\u8D85\u8FC7" + maxSelectedNum + "\u4E2A\u3002");
                return;
            }
        }
        else if (checked && maxNumber > -1 && list.length > maxNumber) {
            message.error("\u4EBA\u6570\u5DF2\u8FBE\u4E0A\u9650\uFF0C\u65E0\u6CD5\u518D\u9009\u62E9\u66F4\u591A\u4EBA\u5458\u52A0\u5165");
            return;
        }
        else if (checked && maxSelectedNum > 0 && list.length > maxSelectedNum) {
            message.error("\u9009\u62E9\u6570\u76EE\u8D85\u8FC7\u4E0A\u9650" + maxSelectedNum);
            return;
        }
        setAllChecked(checked);
        if (dataList && onSelectAll) {
            onSelectAll(dataList, checked);
        }
    }, [
        allChecked,
        result,
        isForwardMode,
        maxSelectedNum,
        dataList,
        strangerResult,
        maxNumber,
        onSelectAll,
        maxSelectedSingleNum,
    ]);
    if (single || !canSelectAll) {
        return null;
    }
    useEffect(function () {
        if (dataList && dataList.length) {
            var count_1 = 0;
            var disabledCount_1 = 0;
            dataList.forEach(function (item) {
                if (item.checked) {
                    count_1++;
                }
                if (item.disabled) {
                    disabledCount_1++;
                }
            });
            if (dataList.length === count_1) {
                setAllChecked(true);
                if (dataList.length === disabledCount_1) {
                    setDisabled(true);
                }
                else {
                    setDisabled(false);
                }
            }
            else {
                setAllChecked(false);
            }
        }
    }, [dataList, result]);
    return (dataList.length > 0 && (React.createElement("div", { className: "select-all-item", onClick: selectAll },
        React.createElement(Checkbox, { style: { marginRight: '12px' }, disabled: disabled, checked: allChecked }),
        React.createElement("div", { className: "all-word" }, "\u5168\u9009"))));
}
//# sourceMappingURL=SelectAll.js.map